var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartisiablockchain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 440,
    viewBox: "0 0 440 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284.4 0C207.5 0 143.6 56.8 132.4 130.7H34.5C15.5 130.7 0 146.1 0 165.2V403.7C0 422.7 15.4 438.2 34.5 438.2H273C292 438.2 307.5 422.8 307.5 403.7V305.8C381.4 294.7 438.2 230.7 438.2 153.8C438.1 69 369.1 0 284.4 0ZM307.4 258.9V184.7C324.5 172 328 147.8 315.3 130.8C302.6 113.7 278.4 110.2 261.4 122.9C244.3 135.6 240.8 159.8 253.5 176.8C255.7 179.8 258.4 182.4 261.4 184.7V392H46.1V176.7H130.7V253.4C113.6 266.1 110.1 290.3 122.8 307.3C135.5 324.4 159.7 327.9 176.7 315.2C193.8 302.5 197.3 278.3 184.6 261.3C182.4 258.3 179.7 255.7 176.7 253.4V153.6C176.7 94.2 224.9 46 284.3 46C343.7 46 392 94.3 392 153.7C392 204.3 356.8 248 307.4 258.9Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartisiablockchain);
export default __webpack_public_path__ + "static/media/partisiablockchain.c7db4f21e557bf28d84aa7fc66148e73.svg";
export { ForwardRef as ReactComponent };